'use client';

import dynamic from 'next/dynamic';

// Social icons (~5KB of inline SVG path data) are below the fold on every
// page and not required for LCP. Load them as a single client-only chunk so
// they never appear in the SSR/RSC payload. The skeleton reserves the exact
// 24×24 dimensions of the rendered icons to prevent layout shift.
const SocialIconByName = dynamic(() => import('./social-icons-group'), {
  ssr: false,
  loading: () => <SocialIconSkeleton />,
});

function SocialIconSkeleton() {
  return (
    <div
      aria-hidden
      className="h-6 w-6 rounded-full bg-[hsl(var(--contrast-100))]/40"
    />
  );
}

export function SocialIconLazy({ name }: { name: string }) {
  return <SocialIconByName name={name} />;
}
